/* eslint-disable global-require */

'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./AppContainer.prod');
} else {
  module.exports = require('./AppContainer.dev');
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-hot-loader/lib/AppContainer.js
 ** module id = 1299
 ** module chunks = 0
 **/